import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=5830abd7&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"
import style0 from "./Language.vue?vue&type=style&index=0&id=5830abd7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830abd7",
  null
  
)

export default component.exports